export const learnAboutMsaUrl =
  "https://docs.microsoft.com/azure/active-directory/external-identities/microsoft-account";

export const idAtXboxUrl = "https://news.xbox.com/en-us/idatxbox/";

export const idXboxAccelerationProgramUrl =
  "https://news.xbox.com/en-us/2023/03/21/id-xbox-developer-acceleration-program-underrepresented-creators/";

export const uwpStorePoliciesUrl = "https://docs.microsoft.com/windows/uwp/publish/store-policies";

export const liveXblOverviewUrl =
  "https://docs.microsoft.com/gaming/gdk/_content/gc/live/get-started/live-xbl-overview";

export const partnerCenterUrl = "https://developer.microsoft.com/microsoft-store/register/";

export const enrollAsDeveloperForMicrosoftStore = "https://go.microsoft.com/fwlink/?linkid=2326308";

export const microsoftGraphProfilePictureUrl = "https://graph.microsoft.com/v1.0/me/photo/$value";

export const microsoftGraphProfileUrl = "https://graph.microsoft.com/v1.0/me/";

export const privacyPolicyURL = "https://privacy.microsoft.com/privacystatement";

export const appDeveloperAgreement = "http://go.microsoft.com/fwlink/?LinkId=528905";

export const linkToPitchForm = "https://forms.office.com/r/UauihhdMiB";

export const siteLocationPrefix = "/games/publish";

export const supportSiteLocationPrefix = "/games/support";

export const storeContentPoliciesUrl =
  "https://learn.microsoft.com/windows/apps/publish/store-policies#111-general-content-requirements";

// Dev Resources
export const GameDevelopmentUrl = "https://docs.microsoft.com/gaming/";
export const GdkDocumentsUrl = "https://aka.ms/gamedevdocs";
export const XboxGdkSamplesUrl = "https://github.com/microsoft/Xbox-GDK-Samples/";
export const LatestGdkReleaseUrl = "https://github.com/microsoft/GDK/releases";
export const XboxDevForumsUrl = "https://aka.ms/xboxdeveloperforums";
export const XgdUrl = "https://aka.ms/xgd";
export const GdkDownloadUrl = "https://aka.ms/gdkdl";
export const XboxPublisherGuideUrl = "https://aka.ms/xboxpublisherguide";
export const XdkDownloadUrl = "https://aka.ms/xgddl";
export const EdsUrl = "https://gamedevstore.partners.extranet.microsoft.com";
export const GetVerifiableCredentials =
  "https://learn.microsoft.com/en-us/partner-center/enroll/get-verifiable-credentials";
